
const Country = Backbone.Model.extend({
  defaults: {
    countryId: null,
    countryDesc: '',
    Value: null,
    Text: ''
  },
  idAttribute: 'countryId',
  initialize() {
    this.set({ Value: this.get('countryId'), Text: this.get('countryDesc') });
  }
});

const Countries = Backbone.Collection.extend({
  model: Country,
  url: `${$('body').data('apidomain')}lookup/countries`,
	fetched: false,
	initialize() {
		this.on('sync', () => {
			this.fetched = true;
		});
		this.fetch();
	},
	parse(resp, opts) {
		return resp.countries;
	}
});

export default Countries;
